import { useContext, useEffect } from 'react';
// Use common track event because we need to manually add the request ids to the events, otherwise they will be out-of-date
import { useTrackEvent } from '~/context/common/AnalyticsProvider';
import InventoryContext, {
  useRequestIds
} from '~/context/srp/InventoryContext';
import SuggestedFiltersContext from '~/context/srp/SuggestedFiltersContext';

export default function useTrackSuggestedFilters() {
  const { inventory } = useContext(InventoryContext);
  const { suggestedFilters, suggestedFiltersRequestId } = useContext(
    SuggestedFiltersContext
  );
  const trackEvent = useTrackEvent();
  const requestIds = useRequestIds();

  const isLoaded = inventory.isLoaded && suggestedFilters.isLoaded;

  useEffect(() => {
    if (!isLoaded) return;

    if (suggestedFilters.error) {
      trackEvent('Suggested filters', {
        action: 'errored',
        error: suggestedFilters.error,
        ...requestIds
      });
    } else {
      trackEvent('Suggested filters', {
        action: 'loaded',
        suggestedFilters: suggestedFilters.data,
        suggestedFiltersRequestId,
        ...requestIds
      });
    }
  }, [
    isLoaded,
    requestIds,
    suggestedFilters.data,
    suggestedFilters.error,
    suggestedFiltersRequestId,
    trackEvent
  ]);
}
